import "./App.css";
import { Navbar } from "./components/Navbar";
import { Book } from "./components/Book";
import { ParkRules } from "./components/ParkRules";
import { ParkMap } from "./components/ParkMap";
import { UnservicedSites } from "./components/UnservicedSites";
import { RegularServicedSites } from "./components/RegularServicedSites";
import { PremiumServicedSites } from "./components/PremiumServicedSites";
import { Premium50AmpSites } from "./components/Premium50AmpSites";
import { Sites } from "./components/Sites";
import { Rentals } from "./components/Rentals";
import { Home } from "./components/Home";
import { Contact } from "./components/Contact";
import {
  Container,
  Card,
  createTheme,
  CssBaseline,
  ThemeProvider,
  CardMedia,
  Grid,
  CardContent,
  Typography,
} from "@mui/material";
import {
  HashRouter,
  createHashRouter,
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
  Outlet,
} from "react-router-dom";
import { Rates } from "./components/Rates";
import { Park } from "./components/Park";
import { WhatsInTheArea } from "./components/WhatsInTheArea";
import { WinterStorage } from "./components/WinterStorage";
import { WaterAccess } from "./components/WaterAccess";
import { Test } from "./components/Test";
import { BookingRequestSent } from "./components/BookingRequestSent";
import { StoreItems } from "./components/StoreItems";
import { BookingError } from "./components/BookingError";
import { BareCampsite } from "./components/BareCampsite";
import { BookingForm } from "./components/BookingForm";
import { Quiz } from "./components/Quiz";
import { WaterfrontCabin } from "./components/WaterfrontCabin";
import Availability from "./components/Availability";
import CompleteAvailability from "./components/CompleteAvailability";

// Custom colors
const theme = createTheme({
  palette: {
    primary: {
      main: "#013415",
    },
    secondary: {
      main: "#fff",
    },
  },
  components: {
    MuiFormHelperText: {
      styleOverrides: { root: { marginTop: 0, height: 0 } },
    },
  },
});

function App() {
  //Right now I switched to createhashRouter, which may or may not be the best solution. Another thing to try
  //is an answer really far down on this page: https://stackoverflow.com/questions/27928372/react-router-urls-dont-work-when-refreshing-or-writing-manually
  //search for ASP.NET Core on this page and it'll bring you to the answer you want
  const router = createHashRouter(
    createRoutesFromElements(
      <Route path="/" element={<Root />}>
        <Route index element={<Home />} />
        <Route path="/book" element={<Book />} />
        <Route path="/map" element={<ParkMap />} />
        <Route path="/rules" element={<ParkRules />} />
        <Route path="/rates" element={<Rates />} />
        <Route path="/sites" element={<Sites />} />
        <Route path="/unservicedsites" element={<UnservicedSites />} />
        <Route
          path="/regularservicedsites"
          element={<RegularServicedSites />}
        />
        <Route
          path="/premiumservicedsites"
          element={<PremiumServicedSites />}
        />
        <Route path="/premium50ampsites" element={<Premium50AmpSites />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/rentals" element={<Rentals />} />
        <Route path="/park" element={<Park />} />
        <Route path="/area" element={<WhatsInTheArea />} />
        <Route path="/winterstorage" element={<WinterStorage />} />
        <Route path="/wateraccess" element={<WaterAccess />} />
        <Route path="/test" element={<Test />} />
        <Route path="/bookingformsent" element={<BookingRequestSent />} />
        <Route path="/bookingerror" element={<BookingError />} />
        <Route path="/storeitems" element={<StoreItems />} />
        <Route path="/barecampsite" element={<BareCampsite />} />
        <Route path="/bookingform" element={<BookingForm />} />
        <Route path="/waterfrontcabin" element={<WaterfrontCabin />} />
        {/* <Route path="/quizhome" element={<QuizHome/>}/> */}
        <Route path="/quiz/:difficulty" element={<Quiz />} />
        <Route path="/availability" element={<Availability />} />
        <Route
          path="/completeavailability/:linkcreateddate"
          element={<CompleteAvailability />}
        />
      </Route>,
    ),
  );

  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <RouterProvider router={router} />
      </div>
    </ThemeProvider>
  );
}

const Root = () => {
  return (
    <div>
      <Navbar />
      <div>
        <Outlet />
      </div>
    </div>
  );
};

export default App;
